/**
 * Requires
 */

import $ from 'jquery'
import { getHexColor } from './carousel'

/**
 * Variables
 */

const updateColor = $('[data-update-header-color]')
const mainMenu = $('[data-main-menu]')
const header = $('[data-header]')
const menuButton = $('[data-menu-button]')

/**
 * Initialisation
 */

export function initialise() {
  if (updateColor.length && mainMenu.length) {
    const color = updateColor.attr('data-update-header-color')
    const hexColor = getHexColor(color)

    header.css('color', hexColor || '#FF32AA')
    menuButton.css('color', hexColor || '#FF32AA')
    mainMenu.addClass(color)
  }
}
